import { render, staticRenderFns } from "./arrangeClass.vue?vue&type=template&id=6c85b0a7&scoped=true"
import script from "./arrangeClass.vue?vue&type=script&lang=js"
export * from "./arrangeClass.vue?vue&type=script&lang=js"
import style0 from "./arrangeClass.vue?vue&type=style&index=0&id=6c85b0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85b0a7",
  null
  
)

export default component.exports